export enum Duration {
  FOREVER = "forever",
  ONCE = "once",
  REPEATING = "repeating",
}

export interface StripeCoupon {
  amountOff: number;
  currency?: string;
  description?: string;
  duration?: Duration;
  durationInMonths: number;
  percentOff: number;
  dueAmount: number;
}
